import React from 'react';
import 'rc-banner-anim/assets/index.css';
import { Col, Image, Row, Tabs } from 'antd';
import { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

const Content2 = (props) => {
  const { dataSource, ...restProps } = props;
  const { t, i18n } = useTranslation();
  const { titleWrapper, page } = dataSource;

  const items: TabsProps[] = [
    {
      key: '1',
      label: t('product.ota.overallPlan'),
      children: (
        <div style={{ textAlign: 'center' }}>
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t(titleWrapper.children[0].children)}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              {titleWrapper.children[1].children}
            </h2>
          </div>
          <Image src={require(`@/assets/production/ota/ota-02${i18n.language === 'en' ? '_en' : ''}.png`)} />
        </div>
      )
    }, {
      key: '2',
      label: t('product.ota.deltaIntroduction'),
      children: (
        <div style={{ textAlign: 'center' }}>
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t('product.ota.deltaIntroduction')}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              DIFFERENCE ALGORITHM
            </h2>
            <div className={'ota-content2-block-content'}>
              <p>{t('product.ota.productCharacteristics')}</p>
              <Row>
                <Col md={12} xs={24}>{t('product.ota.characters01')}</Col>
                <Col md={12} xs={24}>{t('product.ota.characters02')}</Col>
                <Col md={12} xs={24}>{t('product.ota.characters03')}</Col>
                <Col md={12} xs={24}>{t('product.ota.characters04')}</Col>
                <Col md={12} xs={24}>{t('product.ota.characters05')}</Col>
                <Col md={12} xs={24}>{t('product.ota.characters06')}</Col>
                <Col md={12} xs={24}>{t('product.ota.characters07')}</Col>
                <Col md={12} xs={24}>{t('product.ota.characters08')}</Col>
              </Row>
            </div>
          </div>

          <Image src={require('@/assets/production/ota/ota-12.png')} />
        </div>
      )
    }
  ];

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <div key="content2" style={{ background: '#fff' }}>
          <Tabs defaultActiveKey="1" centered items={items}></Tabs>
        </div>
      </div>
    </div>
  );
};

export default Content2;
